import Chip from './chip';
import EntityHelper from '../helpers/entity';

export default class Dashboard {
  constructor(data) {
    EntityHelper.validateData(data);
    const {
      id, disabled, title, locale,
    } = data;

    this.id = EntityHelper.setId(id);
    this.title = title || '';
    this.locale = locale;
    this.disabled = disabled;
  }

  asChip() {
    return new Chip({
      id: this.id,
      color: 'blue-darken-4',
      title: this.title,
      type: Dashboard,
    });
  }
}
